import dynamic from 'next/dynamic';
export const StepBlackHero = dynamic(() => import('./step-black-hero'));